import React from "react";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import { cls } from "app/utils";
import closeIcon from "../../../../../../public/images/close-icon.svg";
import styles from "./styles.module.scss";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  panelClassName?: string;
  bodyClassName?: string;
}

const StepConfigPanel = ({
  isOpen,
  onClose,
  title,
  children,
  panelClassName,
  bodyClassName,
}: IProps) => {
  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      classNames={styles.panel_popup}
    >
      <div className={cls(styles.panel, panelClassName)}>
        <div className={styles.panel_header}>
          <h2 className={styles.panel_title}>{title}</h2>
          <img
            src={closeIcon}
            alt="close"
            className={styles.close_icon}
            onClick={onClose}
          />
        </div>
        <div className={cls(styles.panel_body, bodyClassName)}>
          {children}
        </div>
      </div>
    </ModalLayout>
  );
};

export default StepConfigPanel;
